<template>
  <div
    :id="panelId"
    class="tab-list__panel"
    role="tabpanel"
    tabindex="0"
    :aria-labelledby="controlId"
  >
    <slot />
  </div>
</template>

<script>

/**
 * Vue: Tab panel (tab-panel)
 * -----------------------------------------------------------------------------
 * A tab panel wrapper for tab lists
 *
 */
export default {
  name: 'TabPanel',

  props: {
    namespace: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  computed: {

    /**
     * Compute the panel ID
     * @returns {string}
     */
    panelId() {
      return `${this.namespace}-tabpanel-${this.index}`
    },

    /**
     * Compute the control ID (for aria-labelledby)
     * @returns {string}
     */
    controlId() {
      return `${this.namespace}-tab-${this.index}`
    },
  },
}
</script>
